module.exports = "/images/Product and Service Sales Funnels 1.svg?b7d0fe9f401bfdcf084c98cedc0f9816";